import React from 'react'
import { WidgetGuard } from 'features/types'
import WaveLoading from 'components/share/WaveLoading'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { PatchedPostMetricResult } from 'schemas/PostMetricResultSchema'

const WidgetLoadingGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<PatchedPostMetricResult>(widgetId)

  if (!widgetData || widgetData.status === 'loading') return <WaveLoading />

  return children
}

export default WidgetLoadingGuard
